import camelcaseKeys from 'camelcase-keys'

import { Station } from '@/entities/Station'

export class ExtendedTransaction {
  constructor (params = {}) {
    const { transaction, station } = params ? camelcaseKeys(params, { deep: true }) : {}
    this.transaction = new Transaction(transaction)
    this.station = station ? new Station(station) : null
  }
}

export class Transaction {
  constructor (params = {}) {
    const { id, sequence, externalIds, amount, paymentMethodId, accountId, guestId, currencyId, type, created, concept, reference, notified, attributes, stationId, operatorId, relatedTransactionId, relatedTransactionIds, exchangeCurrencyId, exchangeValue, orderId, serviceId } = params ? camelcaseKeys(params, { deep: true }) : {}
    this.id = id || null
    this.type = type || null
    this.amount = amount || null
    this.guestId = guestId || null
    this.created = created || null
    this.concept = concept || null
    this.orderId = orderId || null
    this.sequence = sequence || null
    this.notified = notified || null
    this.stationId = stationId || null
    this.serviceId = serviceId || null
    this.accountId = accountId || null
    this.reference = reference || null
    this.currencyId = currencyId || null
    this.attributes = attributes || null
    this.operatorId = operatorId || null
    this.externalIds = externalIds || null
    this.exchangeValue = exchangeValue || null
    this.paymentMethodId = paymentMethodId || null
    this.exchangeCurrencyId = exchangeCurrencyId || null
    this.relatedTransactionId = relatedTransactionId || null
    this.relatedTransactionIds = relatedTransactionIds || null
  }
}
